import ExpressButtons from './ExpressButtons';

export default function PaypalButton({ amountInMinorUnits, currency, isMonthly, coverFee, onComplete }) {
  if (!(window.ENV.PAYPAL_ENABLED && window.ENV.STRIPE_ACCOUNT_PUBLIC_KEY)) return null;

  return <>
    <ExpressButtons paypalButton amountInMinorUnits={amountInMinorUnits} currency={currency} isMonthly={false} coverFee={coverFee} onComplete={onComplete} visible={!isMonthly} />
    <ExpressButtons paypalButton amountInMinorUnits={amountInMinorUnits} currency={currency} isMonthly={true} coverFee={coverFee} onComplete={onComplete} visible={isMonthly} />
  </>
}
